import React, { useState } from "react";
import { TableContext } from "../../index";
import { debug } from "../../utils";
import { useHistory } from "react-router-dom";
import ValidateTableHeader from "./ValidateTableHeader";
import ValidateTable from "./ValidateTable";
import { ValidateTableManagement } from "./ValidateTableManagement";
import PaginationManager from "../../view/PaginationManager";
import * as ruleService from "../ruleService";

function ValidateTableSection(props) {

    const history = useHistory();

    const initTableConfig = {
        selected: [],
        filtersLoading: true,
        isLoading: false,
        //whitelist: false,
        devices: [], //device array with rulePk field
    }

    const [tableConfig, setTableConfig] = useState(initTableConfig);

    const changeTableConfig = (config) => {
        debug("Table config changed:", config);
        setTableConfig(config);
    }

    return (
        <>
            {/* {showModal && <ScheduleValidationCardModal handleClose={onCloseModal} {...modalProps}/>} */}
            <TableContext.Provider value={{ config: tableConfig, setConfig: changeTableConfig }}>
                <div className="container-fluid" key={history.location}>
                    <div className="row mb-2">
                        <div className="col-12">
                            <div className="card oct_validationtable-card">
                            <ValidateTableManagement />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="card oct_validationtable-card">
                                <ValidateTableHeader />
                                <div className="card-body">
                                    <div className="dataTables_wrapper dt-bootstrap4 no-footer">
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <ValidateTable />
                                                {tableConfig.deviceId > -1 &&
                                                    <PaginationManager
                                                        getPage={ruleService.validationResultListNotRealTimePageable}
                                                        blocked={tableConfig.filtersLoading} />
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </TableContext.Provider>
        </>
    )
}

export default ValidateTableSection;
